import React, { Component } from "react";
import RankTab from "../../../../../components/Rank/RankTab";
import { get } from "../../../../../utils/request";
import "./style.css";
import "../../../../../index.css";
class SubjectRankIntro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      details: null,
    };
  }
  componentDidMount() {
    this.requestDetails();
  }
  render() {
    const { details } = this.state;
    return (
      <div>
        <RankTab subjectActive={true} schoolActive={false}></RankTab>
        <div className="subjectRankIntro_box">
          <div className="subjectRankIntro_explain_box">
            <img
              alt=""
              className="fl"
              src={require("../../../../../images/rank/star.png")}
            ></img>
            <div className="subjectRankIntro_explain_txt_box fl">
              以下排名来源于教育部学位与研究生教育发展中心的第四轮学科评估（不同机构的排名，结果会有差异）
            </div>
            <div className="clear"></div>
          </div>
          <div className="subjectRankIntro_major_box">
            {details != null ? details.subclass_name : ""}
          </div>
          <div className="subjectRankIntro_intro_box">
            {details != null ? details.intro : ""}
          </div>
          {details != null ? (
            <table className="subjectRankIntro_table_box">
              <thead>
                <tr>
                  <th>学校名称</th>
                  <th>地区</th>
                  <th>评估结果</th>
                </tr>
              </thead>
              <tbody>
                {details.rankSubjectSchoolList.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td>{item.city}</td>
                      <td>{item.score}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            ""
          )}
          <div style={{ height: 60 }}></div>
        </div>
      </div>
    );
  }
  /**
   * 请求学科小类详情
   */
  requestDetails = () => {
    let hashId = this.props.match.params.hashId;
    get("/public/v1/rank/subject/school/" + hashId).then((res) => {
      this.setState({
        details: res.data,
      });
    });
  };
}

export default SubjectRankIntro;



// WEBPACK FOOTER //
// ./src/containers/Rank/SubjectRank/components/SubjectRankIntro/index.js